export default {
  title: 'Word lid van {{name}}!',
  default_program_name: 'Beloningsclub',
  savings_highlight: {
    title: 'Word beloond. Elke bestelling, elke keer.',
    subtitle: 'Registreer in seconden en begin punten te verdienen.',
  },
  how_it_works: {
    label: 'Hoe het werkt',
    step_1: {
      title: 'Aanmelden in 30s',
      desc: 'Alleen je telefoonnummer',
    },
    step_2: {
      title: 'Bestel & verdien',
      desc: '{{percentage}}% terug op elke bestelling',
    },
    step_3: {
      title: 'Inwisselen & besparen',
      desc: 'Tot {{amount}} korting per bestelling',
    },
  },
  profile: {
    verified_title: 'Telefoonnummer geverifieerd!',
    verified_subtitle: 'Vul je profiel in om te beginnen met verdienen.',
  },
  form: {
    phone_number: {
      label: 'Telefoonnummer',
      description: 'We sturen een verificatiecode om je identiteit te bevestigen.',
      placeholder: 'Telefoonnummer',
    },
    birthday: {
      label: 'Verjaardag — dag en maand zijn genoeg voor een cadeau 🥳',
      placeholder: 'Verjaardag (optioneel)',
      parts: {
        month: 'Maand',
        day: 'Dag',
      },
    },
  },
  terms:
    'Door je aan te melden ga je akkoord met onze <TermsLink>algemene voorwaarden</TermsLink> en ons <PrivacyPolicyLink>privacybeleid</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Doorgaan',
    verify: 'Verifiëren',
    complete: 'Registratie voltooien',
  },
  toasts: {
    login_success: 'Je bent succesvol ingelogd',
    invalid_code: 'Ongeldige code. Probeer het opnieuw.',
    failed_to_update_profile: 'Profiel bijwerken mislukt. Probeer het opnieuw.',
  },
};
